export default __webpack_public_path__ + "static/media/microbiology-and-micropathology.138847ab.svg";